export default __webpack_public_path__ + "static/media/WF.68c1bf2d.png";